import React from 'react';

/** The full-page card shown instead of the booking form when a reservation link cannot be used. */
const LinkNotAvailable = ({ title, message, hint, action }) => (
  <div style={{
    backgroundColor: '#f7f9fc',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  }}>
    <div role="alert" style={{
      textAlign: 'center',
      maxWidth: '500px',
      padding: '40px',
      backgroundColor: '#fff',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    }}>
      <h1 style={{ fontSize: '24px', color: '#333', marginBottom: '16px' }}>
        {title}
      </h1>
      <p style={{ fontSize: '16px', color: '#666', lineHeight: '1.6', marginBottom: '24px' }}>
        {message}
      </p>
      {hint && (
        <p style={{ fontSize: '14px', color: '#999' }}>
          {hint}
        </p>
      )}
      {action}
    </div>
  </div>
);

export default LinkNotAvailable;
